export default "__VITE_ASSET__CfZlyuhn__"